import React, { Component } from 'react';
import bgImage from  './assets/bg_pap.jpg';
import styles from  './styles.js';

class BagOm extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
			backgroundImage: `url(${bgImage})`,
			backgroundSize: 'cover'

		});

		return (
			<div style={elmStyl} className='quotes'>
				<div style={styles.flex}>

						<div style={styles.textComponent}>
							<div style={styles.textComponentInner}>
								<h1>Hvad synes du om Byg Et Digt? </h1>
								<div>
									<p>
									4. klasse på Gadehaveskolen 
									sjovt - nye ord -  arbejde godt sammen -  sjove digte -  ligesom  at lede efter lego -   udfordrende -  lære nye ord -  lave mange ord -  ordene var der allerede
									</p>
									<h3>Skoleleder: Sune Bjerglund Nielsen</h3>
									<p>
									
									
									meningsgivende proces fordi der er et tydeligt mål, men facit er ikke givet på forhånd.
									meget eksperimenterende - innovativt - skabende - lege med sproget. 
									Det at prøve noget af, være nysgerrig er i sig selv er en kvalitet og har værdi.
									Børnene var engagerede på tværs af køn, niveauer og kan samarbejde.
									</p>
									
								</div>
							</div>
						</div>


				</div>
			</div>

		)
	}
}

export default BagOm;






// WEBPACK FOOTER //
// ./src/components/BagOm.js